// extracted by mini-css-extract-plugin
module.exports = {"packages":"dd31006766--packages--yWwoR"};